module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-popup', {
    staticClass: "switchProfilePopup",
    attrs: {
      "id": _vm.nameId,
      "opened": _vm.popupOpened
    },
    on: {
      "popup:opened": function($event) {
        _vm.popupOpened = true
      },
      "popup:closed": function($event) {
        _vm.popupOpened = false
      }
    }
  }, [_c('div', {
    staticClass: "switchProfileBack"
  }, [_c('div', {
    staticClass: "switchProfileContent"
  }, [_c('div', {
    staticClass: "switchProfileTitleBox"
  }, [_c('a', {
    staticClass: "switchProfileTitle"
  }, [_vm._v(_vm._s(_vm.$t('leftPanelTitle.swtch_prfl')))])]), _vm._v(" "), _c('f7-list', {
    staticClass: "switchProfileList",
    attrs: {
      "media-list": ""
    }
  }, _vm._l((_vm.accounts), function(accountItem) {
    return _c('f7-list-item', {
      key: accountItem.id,
      staticClass: "boxRequest",
      class: {
        'disabled': false
      },
      attrs: {
        "media": '<div class=\'manualChip\'>' + accountItem.name[0].toUpperCase() + '</div>',
        "title": accountItem.name,
        "subtitle": accountItem.identifier,
        "badge": _vm.selected(accountItem.id),
        "text": ""
      },
      on: {
        "click": function($event) {
          return _vm.switchAccount(accountItem.id)
        }
      }
    })
  }), 1), _vm._v(" "), _c('f7-link', {
    staticClass: "cancelContainer"
  }, [_c('div', {
    staticClass: "cancelBox"
  }, [_c('f7-button', {
    staticClass: "confirmationButtonActivation close-popup"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.bck')) + "  "), _c('f7-icon', {
    attrs: {
      "size": "14px",
      "f7": "undo"
    }
  })], 1)], 1)])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-59e67636", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59e67636","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/switchProfile/switchProfile.vue
// module id = 2365
// module chunks = 2